import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  currentTurboFrameId(event, fallback = "quick_look_cancel_lesson") {
    const frame = event?.currentTarget?.closest("turbo-frame");
    return frame?.id || fallback;
  }

  renderTurboStream(content) {
    if (window.Turbo && typeof window.Turbo.renderStreamMessage === "function") {
      window.Turbo.renderStreamMessage(content);
      return true;
    }
    return false;
  }

  cancelLesson(event) {
    event.preventDefault();
    if (this.isCancelling) return;

    this.isCancelling = true;
    event.currentTarget.classList.add("Button--disabled");

    const cancellationReasonId = this.data.get("cancellationReasonId");
    const cancellationReason = document.getElementById(cancellationReasonId);
    const url = new URL(this.data.get("url"), window.location.origin);
    url.searchParams.set("reason", cancellationReason ? cancellationReason.value : "");

    // Keep guardian context when a guardian cancels from the student dashboard.
    const urlParams = new URLSearchParams(window.location.search);
    const guardianPupil = urlParams.get("guardian_pupil");
    if (guardianPupil) {
      url.searchParams.set("guardian_pupil", guardianPupil);
    }

    window.location.href = url.toString();
  }

  payCancelledLesson(event) {
    event.preventDefault();
    const url = this.data.get("payUrl");
    window.location.href = url;
  }

  waiveFeeJson(event) {
    event.preventDefault();

    let cancelledLessonId = event.currentTarget.dataset.lessonId;
    if (cancelledLessonId == null) {
      cancelledLessonId = document.getElementById("cancelled-lesson-id").value;
    }

    const url = `/schools/us/dashboard/lessons/${cancelledLessonId}/waive-fee`;

    fetch(url, {
      method: "GET",
      // JSON response
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.text())
      .then((content) => {
        alert("Fee waived");
        window.location.reload();
      })
      .catch((error) => alert("Error waiving fee"));
  }

  waiveFee(event) {
    event.preventDefault(); // Prevent the default form submission
    let cancelledLessonId = event.currentTarget.dataset.lessonId;
    if (cancelledLessonId == null) {
      cancelledLessonId = document.getElementById("cancelled-lesson-id").value;
    }

    const turboFrameId = this.currentTurboFrameId(event);

    const url = `/schools/us/dashboard/lessons/${cancelledLessonId}/waive-fee`;

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "Turbo-Frame": turboFrameId,
      },
    })
      .then((response) => response.text())
      .then((content) => {
        const rendered = this.renderTurboStream(content);
        if (!rendered) {
          window.location.reload();
        }
      })
      .catch((error) => console.error(error));
  }

  sendEmailReminder(event) {
    event.preventDefault(); // Prevent the default form submission
    let feeId = event.currentTarget.dataset.feeId;

    if (feeId == null) {
      alert("Error sending email reminder");
      return;
    }

    const turboFrameId = this.currentTurboFrameId(event);

    const url = `/schools/us/dashboard/lessons/${feeId}/email-reminder`;

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "Turbo-Frame": turboFrameId,
      },
    })
      .then((response) => response.text())
      .then((content) => {
        this.renderTurboStream(content);
        alert("Email reminder sent");
      })
      .catch((error) => console.error(error));
  }
}
